import {
  DataTable,
  DataTableProps,
} from "../../../components/common/data-table/DataTable";
import Loading from "../../../components/Loading";
import { ColumnInterface } from "../../../interfaces/customTableInterface";
import { DealerInterface } from "../../../interfaces/dealerInterface";

type DealerRow = DealerInterface & { state?: string; city?: string };

type DealerTableProps = {
  data: DealerRow[];
  isLoading: boolean;
} & Pick<
  DataTableProps<DealerRow>,
  "pagination" | "extraActions" | "sortBy" | "sortOrder" | "onSort"
>;

const columns: ColumnInterface<DealerRow>[] = [
  { key: "dealerId", label: "No." },
  { key: "name", label: "Nombre" },
  { key: "state", label: "Estado", sortable: false },
  { key: "city", label: "Ciudad", sortable: false },
  { key: "distributorType", label: "Tipo de distribuidor" },
];

export const DealerTable = (props: DealerTableProps) => {
  const { isLoading, ...rest } = props;

  if (isLoading) return <Loading />;

  return (
    <DataTable
      columns={columns}
      tableId="dealers-table"
      customRender={(key, item) => {
        if (key === "distributorType") {
          return item.distributorType?.name ?? "";
        }
        return item[key] ?? "N/A";
      }}
      {...rest}
    />
  );
};
